<template>
    <b-modal
        ref="concern-elements-modal"
        cancel-variant="outline-secondary"
        ok-title="Save"
        @ok="onSave"
        size="xl"
        cancel-title="Close"
        centered
        :title="title"
        hide-footer
        @hidden="hidden"
    >
        <template #modal-header="{ close }">
            <h5>{{ title }}</h5>
            <!-- Emulate built in modal header close button action -->
            <Button size="sm" variant="primary" @click="close()">
                {{ $t('Component(ConcernElementsModal):header-close-button') }}
            </Button>
        </template>
        <ConcernElements
            :product="this.product"
            :company-has-information="companyHasInformation"
            :included-substances="includedSubstances"
            :excluded-substances="excludedSubstances"
            :instruction="instruction"
            :show-information-owner-settings="showInformationOwnerSettings"
            :legislations="legislations"
            @listQuestionStateUpdated="listQuestionStateUpdated"
            @undefined="onUndefined"
            @include="include"
            @exclude="exclude"
        />
    </b-modal>
</template>

<script>
import { BModal, BTable, BFormGroup, BFormRadioGroup, BButton } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import {ConcernElements} from "@/views/product/components/product-card";
import {NestedTable} from "@core/components/common";
import {getNameOrId, ProductNames} from "@/libs/product";
import {Button} from "@core/components/common";

export default {
    components: {
        Button,
        BButton,
        BFormRadioGroup,
        ConcernElements,
        vSelect,
        BFormGroup,
        BTable,
        BModal,
        NestedTable,
    },
    directives: {
        Ripple
    },
    props: {
        instruction: {
            default() {
                return this.$t('Page(ProductCard-ConcernElements):Component(Text):hint');
            }
        },
        product: {
            type: Object,
            default() {
                return {};
            }
        },
        showInformationOwnerSettings: {
            default: false,
        },
        companyHasInformation: {
            default: false,
        },
        includedSubstances: {
            type: Array,
            default() {
                return [];
            }
        },
        excludedSubstances: {
            type: Array,
            default() {
                return [];
            }
        },
        legislations: {
            default() {
                return null;
            }
        }
    },

    methods: {
        hidden() {
          this.$emit('modalClosed');
        },
        onSave() {
            console.log('save');
        },

        show() {
            this.$refs['concern-elements-modal'].show();
        },

        hide() {
            this.$refs['concern-elements-modal'].hide();
        },

        listQuestionStateUpdated(list, state) {
            this.$emit('listQuestionStateUpdated', list, state);
        },

        include(substance, substanceListIds = []) {
            this.$emit('include', substance, substanceListIds);
        },

        onUndefined(substance) {
            this.$emit('undefined', substance);
        },

        exclude(substance) {
            this.$emit('exclude', substance);
        },
    },

    computed: {
        title() {
            let title = this.product.title || getNameOrId(this.product.names, ProductNames.OUR_PRODUCT_NAME);
            return this.$t('Component(ConcernElementsModal):title', {product: title})
        }
    },
}
</script>
